import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import StatusChip from "../../../app/features/tender/components/view/Status";
import { isEmpty, isNull, isUndefined } from "lodash";
import { useSelector } from "react-redux";
import { RootState } from "@/store/type";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { LANG, ROLE } from "@/types";
import QuotationDetailsModal, {
  QuotationType,
} from "@/pages/buyer/home/components/lobby/responsiveSeller/Wedgits/QuotationDetailsModal";
import AcceptQuatationSubmit from "@/app/features/tender/components/view/quatation-accept-sbmit";
import { routes } from "@/consts";
import { showToast } from "@/app/global-components/toaster";
import useOrder from "@/hooks/use-order";
import { useNavigate } from "react-router-dom";
import useOffer from "@/hooks/useTender";
import TableComponent from "@/app/global-components/table";
import { Eye } from "lucide-react";

interface OfferQuatationslist {
  offerID?: string;
  offerStatus?: string;
  listOffers: QuotationType[];
  totalPages: number;
  // updateNew: () => void;
}

interface Product {
  productId: string;
  DeliveryMethod: string;
  unitName: string;
  quatationId: string;
  quantity: number;
  unitPrice: number;
  vat: number;
  notice: string;
  attachment?: File | null;
  images?: null | string[] | undefined;
}

export interface TenderQuotation {
  tender: { title: string; id: string; status: string };
  id: string;

  status: string;
  products: Product[];
  company: {
    CompanyNr: string;
    nameAr: string;
  };
}

const ListofQuatations: React.FC<OfferQuatationslist> = ({
  listOffers,
  offerStatus,
  // updateNew,
}) => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);

  const [selectedQuotation, setSelectedQuotation] =
    React.useState<QuotationType | null>(null);
  const authUser = useSelector((state: RootState) => state.auth.authUser);
  const userRole = isUndefined(authUser?.role) ? "" : authUser?.role;

  const myCompany = useSelector((state: RootState) => state.auth.myCompany);
  const { createOrder } = useOrder();
  const quatation = useSelector((state: RootState) => state.auth.quatation);

  let product: Product[] = [];

  listOffers.forEach((element) => {
    element.products.forEach((productItem) => {
      if (
        quatation?.selectedItems?.some((item) => item === productItem.productId)
      ) {
        product.push({
          ...productItem,
          quatationId: element.id,
          DeliveryMethod: element.DeliveryMethod,
        });
      }
    });
  });
  const handleAction = async (action: Function, id: string | undefined) => {
    if (product && id) {
      try {
        await action(id);
      } catch (err) {
        console.error("Error performing action:", err);
      }
    }
  };

  const { acceptQuatation } = useOffer();
  const navigate = useNavigate();
  const proccessOrder = async () => {
    if (userRole === ROLE.BUYER) {
      const orderData = {
        title: "Order for Tender",
        deliverDate: new Date(
          new Date().getTime() + 7 * 24 * 60 * 60 * 1000
        ).toISOString(), // Deliver in 7 days
        type: "Tiny",
        status: "Planning",
        region: myCompany.region,
        city: myCompany.city,
        address: myCompany.address,
        products: product?.map((item) => ({
          itemId: item.productId,
          item: item.unitName,
          deliveryMethod: item.DeliveryMethod,
          quantity: item.quantity,
          discount: 0,
          price: item.unitPrice,
          vat: item.vat || 15,
          notice: item.notice || "",
          image: item.images ? item.images[0] : "",
          companyId: listOffers.find((element) =>
            element.products.some(
              (product) => product.productId == item.productId
            )
          )?.companyId,
          tender: listOffers[0].tender.id,
          quatationId: item.quatationId,
        })),
        tenderId: listOffers[0].tenderId,
        userId: authUser?.id,
        companyId: myCompany?.id,
        Sendedproducts: [],
        OrderNr: myCompany ? myCompany.orderNr + 1 : 1,
      };

      try {
        setIsPlacingOrder(true);

        const response = await createOrder(orderData); // Assuming createOrder is an API call to save the order
        if (response?.isSuccess) {
          showToast(t("Alert.OrderCreated"), "success");
          handleAction(acceptQuatation, listOffers[0].id);
          navigate(`${routes.order}/${response.data.id}`); // Navigate to the created order's page
        } else {
          showToast(t("Alert.OrderCreationError"), "warning");
        }
      } catch (error) {
        showToast(t("Alert.OrderTryAgain"), "warning");
        console.error("Error creating order:", error);
      } finally {
        setIsPlacingOrder(false);
      }
    }
  };
  const handleViewDetails = (quotation: QuotationType) => {
    setSelectedQuotation(quotation);
  };
  const [isPlacingOrder, setIsPlacingOrder] = React.useState(false);

  const handleCloseDetailsModal = async () => {
    setSelectedQuotation(null);
    // if (offerID) {
    //   // updateNew();
    //   const Total = await getListtenderQuotationsByOfferId(offerID);
    //   if (Total) {
    //     setListOffers(Total.data);
    //     setTotalPages(Math.ceil(Total.data.length / itemsPerPage));
    //   } else {
    //     setListOffers([]);
    //   }
    // }
  };

  const renderSelectedItems = () => {
    return (
      <div className="mt-8">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          {t("general.items")}
        </h3>
        <div className="grid text-center grid-cols-4 gap-4 p-4 bg-gray-50 rounded-lg">
          <div className="font-medium text-gray-700">
            {t("item.fields.image")}
          </div>
          <div className="font-medium text-gray-700">
            {t("checkout.fields.name")}
          </div>
          <div className="font-medium text-gray-700">
            {t("checkout.fields.quantity")}
          </div>
          <div className="font-medium text-gray-700">
            {t("checkout.fields.unitPrice")}
          </div>
        </div>
        {product?.map((item, index) => (
          <div
            key={index}
            className="grid grid-cols-4 gap-4 mt-2 text-center items-center border-t border-gray-100 p-4 hover:bg-gray-50 rounded-lg"
          >
            <img
              className="mx-auto rounded-lg object-cover"
              src={item.images ? item.images[0] : ""}
              width={70}
              height={70}
              alt={item.unitName}
            />
            <div className="text-lg font-semibold text-gray-900">
              {item.unitName}
            </div>
            <div className="text-lg font-semibold text-gray-700">
              {item.quantity}
            </div>
            <div className="text-lg font-semibold text-gray-700">
              {item.unitPrice}
            </div>
          </div>
        ))}
      </div>
    );
  };

  // Prepare data for the table
  const tableData = listOffers.map((item) => ({
    id: item.id,
    tenderTitle: isNull(item.tender) ? "" : item.tender.title,
    companyNr: item.company?.CompanyNr || "",
    totalValue: item.products
      .reduce(
        (acc: number, product: Product) =>
          acc +
          (product.unitPrice ?? 0) *
            (product.quantity ?? 0) *
            (1 + (product.vat ?? 0) / 100),
        0
      )
      .toFixed(2),
    status: isNull(item.status) ? "Opened" : item.status,
    quotation: item,
  }));

  const columns = [
    {
      title: t("navigation.Opportunity"),
      field: "tenderTitle",
      sortable: true,
    },
    {
      title: t("checkout.fields.company"),
      field: "companyNr",
      sortable: true,
    },
    {
      title: t("tender.value"),
      field: "totalValue",
      sortable: true,
      render: (row: any) => (
        <span className="font-semibold text-gray-900">{row.totalValue}</span>
      ),
    },
    {
      title: t("orders.fields.status"),
      field: "status",
      sortable: true,
      render: (row: any) => <StatusChip status={row.status} />,
    },
    {
      title: t("general.actions"),
      field: "actions",
      sortable: false,
      hideOnMobile: false,
      render: (row: any) => (
        <Tooltip title={t("general.view")}>
          <IconButton
            onClick={() => handleViewDetails(row.quotation)}
            sx={{
              color: "#644980",
              "&:hover": {
                backgroundColor: "rgba(59, 130, 246, 0.1)",
              },
            }}
          >
            <Eye size={18} />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  return (
    <div
      style={{
        direction: locale === LANG.EN ? "ltr" : "rtl",
        backgroundColor: "#fff",
        borderRadius: "12px",
        padding: "24px",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          fontWeight: "bold",
          marginBottom: "24px",
          color: "#374151",
          fontSize: "1.5rem",
        }}
      >
        {t("navigation.Quotations")}
      </h2>

      {!isEmpty(listOffers) ? (
        <TableComponent
          columns={columns}
          data={tableData}
          rowKeyField="id"
          maxHeight={600}
          rowsPerPage={7}
          pagination={true}
          searchable={true}
          sortable={true}
          title={t("navigation.Quotations")}
          subtitle={t("general.information")}
          variant="elevated"
          size="md"
          emptyStateMessage={t("offers.noAvailable")}
          emptyStateSubmessage={t("general.noDataMatchingCriteria")}
        />
      ) : (
        <div className="text-center py-12">
          <p className="text-gray-500 text-lg">{t("offers.noAvailable")}</p>
        </div>
      )}

      {selectedQuotation && (
        <QuotationDetailsModal
          open={!!selectedQuotation}
          onClose={handleCloseDetailsModal}
          quotation={selectedQuotation}
          offerStatus={offerStatus}
        />
      )}

      {product.length > 0 && renderSelectedItems()}

      <div className="mt-6 flex justify-end">
        {!!quatation?.selectedItems?.length && (
          <AcceptQuatationSubmit
            isLoading={isPlacingOrder}
            onClick={proccessOrder}
          />
        )}
      </div>
    </div>
  );
};

export default ListofQuatations;
